import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';

import { WebsocketService } from './websockets.service';
import { SecureWebsocketService } from './secure-websocket.service';

export function provideWebsockets(): EnvironmentProviders {
  return makeEnvironmentProviders([
    WebsocketService,
    SecureWebsocketService,
    provideAppInitializer(() => {
      inject(WebsocketService).connect();
    })
  ]);
}
